module.exports = __webpack_public_path__ + "img/menu-btn.0908c893.png";